export default {
  regionSelector: {
    chooseADisasterRegion: 'Seleccione una región de desastre',
    lastUpdate: 'Última actualización'
  }
}
